<template>
	<div 
		class="form-message"
		:class="{ 'qinti': isQinti, 'lucky' : isLucky}">
		<p class="mb-0 text">
			¡Selecciona tu ubicación y <br/>
			<span class="text-big">COMIENZA A VENDER</span>
			con CasaMarket!
		</p>
	</div>
</template>
<script>
	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'form-message',
		props: {
			urlImage: String,
		},
		computed: {
			isQinti,
			isLucky,
		},
	};
</script>

<style lang="scss" scoped>
	.form-message {
		align-items: center;
		height: calc(100vh - 131px);
		display: flex;
		justify-content: center;
		left: 0;
		overflow: hidden;
		position: absolute;
		right: 0;

		@media (min-width: 936px) {
			height: calc(100vh - 194px);
		}

		.text {
			color: color(primary);
			font-size: size(large23);
			font-weight: 900;
		}

		.text-big {
			font-size: size(large27);
		}

		&.qinti {
			.text {
				color: #e4278e;
			}
		}

		&.lucky {
			.text {
				color: map-get($colors, newwarning);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-message.vue